import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { hexToRgbA } from 'utils';
// import CMSFactory from "factories/CMS";
import style from './style.scss';//NOSONAR
import { ecommerce } from 'config/constants';

const VideoPlayer = (props) => {
    let data = props.data ? props.data : null;
    const videoId = data ? data.idVideo || data.url_video : '';
    const [show, setShow] = useState(true);

    useEffect(() => {
        if(data && data.title && data.title.length > 0){
            setShow(false);
        }else{
            setShow(true);
        }

    }, []);

    const _getUrlVideo = (idVideo, play = false) => {
        const autoPlay = play ? '1' : '0';
        return `https://www.youtube.com/embed/${idVideo}?autoplay=${autoPlay}`;
    }

    const styleTexts = {
        backgroundColor: data ? hexToRgbA(data.background_color, data.background_opacity) : ''
    };

    const styleBox = {
        width: (data && data.unit) ? '100%' : ''
    }

    return (
        <div className={'container-video'} style={styleBox} >
            {(data && data.title) && <span className={"container-text-video"} style={styleTexts}>
                <span className="title-video" >{data.title ? data.title : ''}</span>
            </span>}
            {data && <div className={"wrapper-video " + (show ? 'without-title' : '')}>
                <iframe src={_getUrlVideo(videoId, data.autoplay)}
                    frameBorder='0'
                    className="iframe-video"
                    allow='autoplay; encrypted-media'
                    allowFullScreen
                    title={ecommerce.metaTitle}
                />
            </div>}
        </div>
    )
}

VideoPlayer.propTypes = {
    data: PropTypes.object
}
export default VideoPlayer;
